import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/authContext';
import { VehicleProvider } from './context/vehicleContext';
import { NegotiationAlertsProvider } from './context/negotiationAlertsContext';
import { ThemeProvider } from './context/themeContext';
import { analytics } from './services/analyticsService';
import './i18n';

// Initialize Google Analytics asynchronously
analytics.initialize().catch((err) => {
  console.warn('Failed to initialize analytics:', err);
});

if ('Notification' in window && Notification.permission === 'default') {
  Notification.requestPermission();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Service worker registration failed
    });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>  {/* Wrap your app in AuthProvider */}
        <VehicleProvider>
          <NegotiationAlertsProvider>
            <App />
          </NegotiationAlertsProvider>
        </VehicleProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

reportWebVitals();
